<template>
    <div class="actions">
        <RadioGroup class="workshop" :value="selectWSid" size="large" @on-change="selectChange" type="button">
            <Radio v-for="item in workshops" :key="item.ws_id" :label="item.ws_id">{{item.name}}</Radio>
        </RadioGroup>
    </div>
</template>
<script>
export default {
    props: ['workshops', 'selectWSid'],
    methods: {
        selectChange(value) {
            this.$emit('on-change-workshop', value);
        }
    }
};
</script>
<style lang="less">
.actions .workshop .ivu-radio-wrapper{
    margin-right: 15px;
}
</style>





// WEBPACK FOOTER //
// src/views/layoutshop/components/actions.vue